import { httpClient } from './api/httpClient';
import { API_ENDPOINTS } from 'constants/apiEndpoints';

export const toPipelineArticle = (raw) =>
  raw && {
    id: raw.id,
    articleReferenceId: raw.article_reference_id ?? '',
    rootArticleId: raw.root_article_id ?? '',
    currentStage: raw.current_stage ?? 'no_storage',
    originSource: raw.origin_source ?? '',
    workflowState: raw.workflow_state ?? 'completed',
    documentVersion: raw.document_version ?? 1,
    status: raw.status ?? 'stored',
    newspaperName: raw.newspaper_name ?? '',
    edition: raw.edition ?? '',
    keywords: raw.keywords ?? [],
    articleTitle: raw.article_title ?? null,
    headline: raw.headline ?? null,
    pageNumber: raw.page_number ?? null,
    language: raw.language ?? null,
    articleLink: raw.article_image_url ?? raw.article_link ?? null,
    articleImageUrl: raw.article_image_url ?? null,
    newspaperLink: raw.newspaper_page_image_url ?? raw.newspaper_link ?? null,
    newspaperPageImageUrl: raw.newspaper_page_image_url ?? null,
    mergedPdfLink: raw.merged_pdf_url ?? null,
    notes: raw.notes ?? null,
    mergedPdfUrl: raw.merged_pdf_url ?? null,
    mergedPdfStatus: raw.merged_pdf_status ?? null,
    source: raw.source?.type ?? raw.source ?? null,
    isManualUpload: raw.is_manual_upload ?? false,
    previousStage: raw.previous_stage ?? null,
    workflowTimeline: raw.workflow_timeline ?? [],
    createdAt: raw.created_at ?? null,
    createdBy: raw.created_by ?? null,
    updatedAt: raw.updated_at ?? null,
  };

export const noStorageService = {
  async list(params = {}) {
    const data = await httpClient.get(API_ENDPOINTS.NO_STORAGE.LIST, { params });
    return {
      items: (data.items ?? []).map(toPipelineArticle),
      total: data.total ?? 0,
      page: data.page ?? 1,
      pageSize: data.page_size ?? 100,
      totalPages: data.total_pages ?? 0,
    };
  },

  async get(id) {
    const data = await httpClient.get(API_ENDPOINTS.NO_STORAGE.DETAIL(id));
    return toPipelineArticle(data);
  },
};

export default noStorageService;

 